module.exports = __webpack_public_path__ + "media/28.5b3088db.mp3";